export default [
  {
    path: '/generator/packs',
    name: 'generator-packs',
    component: () => import('@/views/generator/PacksList.vue'),
    meta: {
      resource: 'generator',
      action: 'view',
    },
  },
  {
    path: '/generator/packs/:id',
    name: 'generator-pack-detail',
    component: () => import('@/views/generator/PackDetail.vue'),
    meta: {
      navActiveLink: 'generator-packs',
      resource: 'generator',
      action: 'view',
    },
  },
]
